/**
 * Run async `jobs` with at most `limit` in flight at once.
 * `jobs` is an array of `() => Promise<T>`. Results return in input order.
 * If an `AbortSignal` is passed, queued jobs are skipped after abort and
 * in-flight rejections are surfaced as-is.
 */
export async function runWithConcurrency(jobs, limit, signal) {
  const results = new Array(jobs.length);
  let nextIndex = 0;

  async function worker() {
    while (true) {
      if (signal?.aborted) return;
      const i = nextIndex++;
      if (i >= jobs.length) return;
      try {
        results[i] = await jobs[i]();
      } catch (e) {
        results[i] = { __error: e };
      }
    }
  }

  const workers = Array.from({ length: Math.min(limit, jobs.length) }, worker);
  await Promise.all(workers);
  return results;
}
